<template>
  <footer id="footer-section" class="app-footer">
    <div class="app-footer__main">
      <div class="app-footer__content">
        <div class="app-footer__brand">
          <h2 class="app-footer__brand-name">Ramnil</h2>
        </div>
        <div class="app-footer__contact">
          <div class="app-footer__contact-item">
            <span class="app-footer__contact-label">Address</span>
            <span>RM03, 24/F, HO KING COMM CTR, 2-16 FAYUEN ST, MONGKOK，KL</span>
          </div>
        
          <div class="app-footer__contact-item">
            <span class="app-footer__contact-label">Email</span>
            <span>contact@ramnilco.com</span>
          </div>
        </div>
      </div>
    </div>
    <div class="app-footer__copyright">
	  Copyright © 2025 Ramnil All Rights Reserved
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AppFooter',
  computed: {
    ...mapGetters({
      deviceType: 'deviceType',
    })
  },
}
</script>

<style lang="scss">
@import '~@/css/variables.scss';

.app-footer {
	color: #161c2d;
	width: 100%;

	&__main {
		background: #f4f7fa;
		padding: rem(60) rem(180);
	}

	&__content {
		max-width: rem(1080);
		margin: 0 auto;
		flex-direction: column;
		gap: rem(52);
		display: flex;
		justify-content: space-between;
	}

	&__brand-name {
		font-size: rem(24);
		font-weight: 900;
		color: #473bf0;
		text-transform: uppercase;
	}

	&__contact {
		display: flex;
		flex-direction: column;
		gap: rem(24);
		text-align: right;
	}

	&__contact-item {
		display: flex;
		gap: rem(16);
		align-items: center;

		span:last-child {
			border-left: 1px solid rgba(255, 255, 255, 0.2);
			padding-left: rem(16);
			font-size: rem(14);
		}
	}

	&__contact-label {
		color: #848895;
		width: rem(80);
		text-align: left;
		font-size: rem(14);
	}

	&__copyright {
		color: #ffffff;
		font-size: rem(14);
		background: #473bf0;
		text-align: left;
		padding: rem(12) rem(180);
	}

	.detect_deviece_mobile & {
		&__main {
			padding: rem(60) rem(16);
		}

		&__content {
			flex-direction: column;
			gap: rem(40);
		}
		&__contact-label {
			display: block;
			flex-shrink: 0;
		}

		&__contact-item {
			flex-direction: row;
			align-items: flex-start;
			gap: rem(8);

			span:last-child {
				border-left: none;
				padding-left: 0;
				text-align: left;
			}
		}

		&__copyright {
			padding: rem(24) rem(16);
		}
	}
}
</style>
